import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Log } from "app/core/logging/log";
import { UiActionPayload } from "app/models/ui-action-payload";
import { AppService } from "app/services/app/app.service";

@Injectable({ providedIn: 'root' })
export class UiActionService {

  constructor(
    private router: Router,
    private appService: AppService,
    private dialog: MatDialog
  ) {}

  handle(payload: UiActionPayload): void {
    Log.debug('UiActionPayload', {payload});
    
    switch (payload.action) {

      case 'redirect':
        this.router.navigateByUrl(payload.params?.url);
        break;

      case 'refresh':
        window.location.reload();
        break;

      case 'open_modal':
        this.openModal(payload);
        break;

      case 'logout':
        this.router.navigate(['/logout']);
        break;
    }
  }

  private openModal(payload: UiActionPayload): void {
    //const title = payload.i18nKey
    //  ? this.translate.instant(payload.i18nKey, payload.params)
    //  : '';

      const message = this.appService.getTraduccion(payload.i18nKey, payload.params);

       this.appService.showDangerToast(message, 3000);

   // this.dialog.open(GenericModalComponent, {
  //    data: { title, params: payload.params }
   // });
  }
}
